import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AppLogo from '@/components/ui/AppLogo';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-16 px-6 md:px-12 bg-accent border-t border-white/10">
      <div className="w-full max-w-7xl mx-auto">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="mb-4 transition-smooth hover:scale-105 inline-block">
              <AppLogo
                text="Mulumbu Minerals"
                iconName="SparklesIcon"
                size={64}
                className="text-white"
              />
            </div>
            <p className="text-sm font-body text-white/70 leading-relaxed">
              Premium gold export from the heart of Congo. Transparent pricing, international
              compliance, and direct from source.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-display font-bold text-white mb-4 uppercase tracking-wider">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="#pricing-section"
                  className="text-sm font-body text-white/70 hover:text-primary transition-smooth hover:translate-x-2 inline-block"
                >
                  Live Pricing
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm font-body text-white/70 hover:text-primary transition-smooth hover:translate-x-2 inline-block"
                >
                  Certifications
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm font-body text-white/70 hover:text-primary transition-smooth hover:translate-x-2 inline-block"
                >
                  Testimonials
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm font-body text-white/70 hover:text-primary transition-smooth hover:translate-x-2 inline-block"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-base font-display font-bold text-white mb-4 uppercase tracking-wider">
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 group">
                <Icon name="ChatBubbleLeftRightIcon" size={18} className="text-primary group-hover:scale-110 transition-smooth" />
                <a
                  href="https://wa.me/243996739468"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm font-body text-white/70 hover:text-primary transition-smooth"
                >
                  +243 996 739 468
                </a>
              </li>
              <li className="flex items-center gap-3 group">
                <Icon name="EnvelopeIcon" size={18} className="text-primary group-hover:scale-110 transition-smooth" />
                <a
                  href="mailto:info@mulumbuminerals.com"
                  className="text-sm font-body text-white/70 hover:text-primary transition-smooth"
                >
                  info@mulumbuminerals.com
                </a>
              </li>
              <li className="flex items-start gap-3 group">
                <Icon name="MapPinIcon" size={18} className="text-primary mt-1 group-hover:scale-110 transition-smooth" />
                <span className="text-sm font-body text-white/70">
                  North Kivu, Butembo<br />Democratic Republic of Congo
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs font-body text-white/50">
            © {currentYear} Mulumbu Minerals. All rights reserved.
          </p>
          <div className="flex gap-4">
            <a
              href="#"
              className="text-xs font-body text-white/50 hover:text-primary transition-smooth hover:scale-110 inline-block"
            >
              Privacy Policy
            </a>
            <a
              href="#"
              className="text-xs font-body text-white/50 hover:text-primary transition-smooth hover:scale-110 inline-block"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;